<template>
  <div class="confirmation-sent-pane">
    <signup-header-section :steps="1" :pageTitle="$tc('SignupPage.Steps.Step1')" />
    <confirmation-sent-section class="confirmation-sent-pane__content" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SignupHeaderSection from '@/components/SignupPage/common/SignupHeaderSection.vue'
import ConfirmationSentSection from '@/components/SignupPage/ConfirmationSentPane/ConfirmationSentSection.vue'

/**
 * 新規会員登録: 認証メール送信完了ペインのコンポーネント
 */
export default defineComponent({
  name: 'ConfirmationSentPane',
  components: {
    SignupHeaderSection,
    ConfirmationSentSection,
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.confirmation-sent-pane {
  width: 100%;
  min-height: calc(100vh - 48px);
  margin: 0 auto;
  text-align: center;
  background: $gray1;

  &__content {
    width: 100%;
    max-width: 840px;
    margin: 0 auto;
  }
}
</style>
